import SiteService from "../services/site.service";
import Config from "@/config/config.js";
import { getSession } from "@/hooks/useSession.js";

import State, { STATE, CurrentStudyState, CurrentEntityState } from "@state";
import { sha256 } from "@/utils/crypto.js";

/**
 * Frontend controller pour ajouter un site à une étude existante.
 * @param {object} sitePayload – Données du site à insérer.
 * @returns {Promise<object|null>} – Résultat de l’opération ou erreur normalisée.
 */
const addSiteToStudy = async (sitePayload) => {
    console.log("=== addSiteToStudy === study.controller.js === key: 991230 ===");
    console.log("→ Payload reçu:", sitePayload);
    console.log("=================================");
  
    const requiredFields = [
      "site_id",
      "study_id",
      "site_name",
      "site_address",
      "master_icf_id",
      "site_icf_id",
      "site_icf_file_name",
    ];
  
    const missing = requiredFields.filter((field) => !sitePayload[field]);
  
    if (missing.length > 0) {
      console.warn("⚠️ Champs requis manquants:", missing);
      return {
        success: false,
        message: `Champs requis manquants: ${missing.join(", ")}`,
        errorCode: "missing-site-fields",
        errorKey: 991231,
      };
    }
  
    try {
      const response = await SiteService.addSiteToStudy(sitePayload);
  
      console.log("=== Réponse backend === study.controller.js === key: 991232 ===");
      console.dir(response, { depth: null, colors: true });
      console.log("=================================");
  
      return response;
    } catch (error) {
      console.error("Erreur dans addSiteToStudy controller:", error);
      return {
        success: false,
        message: "Erreur lors de l’ajout du site à l’étude",
        fromError: !Config.IN_PROD ? error.message : null,
        errorCode: "add-site-controller-error",
        errorKey: 991233,
      };
    }
  };

  /**
 * Frontend controller pour désactiver un site existant (activated = false)
 * @param {string} siteId – L'identifiant du site à supprimer
 * @returns {Promise<object|null>} – Résultat ou objet d’erreur
 */
const deactivateSiteById = async (siteId) => {
  console.log("=== deactivateSiteById === site.controller.js === key: 991410 ===")
  console.log("→ siteId reçu:", siteId)
  console.log("=================================")

  if (!siteId) {
    console.warn("⚠️ siteId manquant dans deactivateSiteById")
    return {
      success: false,
      message: "Identifiant site requis pour suppression",
      errorCode: "missing-site-id",
      errorKey: 991411,
    }
  }

  try {
    const response = await SiteService.deactivateSiteById(siteId)

    console.log("=== Réponse backend === site.controller.js === key: 991412 ===")
    console.dir(response, { depth: null, colors: true })
    console.log("=================================")

    return response
  } catch (error) {
    console.error("Erreur dans deactivateSiteById controller:", error)
    return {
      success: false,
      message: "Erreur lors de la suppression du site",
      fromError: !Config.IN_PROD ? error.message : null,
      errorCode: "deactivate-site-controller-error",
      errorKey: 991413,
    }
  }
}

  const SiteController = {
addSiteToStudy ,deactivateSiteById,
  };
  
  export default SiteController;
  